import classNames from 'classnames';
import { FC } from 'react';

import { Actionable } from 'root/widgets/common-components';

import './success-view.scss';
import { SuccessViewProps } from './types';

const SuccessView: FC<SuccessViewProps> = ({ icon, title, description, closeAction }) => (
  <div className="aem-sv-root">
    <div className="aem-sv-body">
      <i className={classNames('aem-sv-icon', icon)} />
      <div className="aem-sv-title">{title}</div>
      <div className="aem-sv-description">{description}</div>
    </div>
    <div className="aem-sv-footer">
      <Actionable variant="outline-secondary" {...closeAction} />
    </div>
  </div>
);

SuccessView.displayName = 'SuccessView';

export default SuccessView;
